var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15561 0.442871C3.5368 0.442395 0.601116 3.37665 0.599214 6.99546C0.597311 10.6157 3.52871 13.5528 7.14705 13.5571C10.7659 13.5614 13.7053 10.63 13.7106 7.01211C13.7153 3.38473 10.7806 0.443347 7.15561 0.442871ZM9.69311 11.9972C8.89247 12.4158 8.03665 12.618 7.11042 12.6213C6.1899 12.6137 5.30268 12.3873 4.47111 11.9392C4.37692 11.8883 4.34172 11.8402 4.36075 11.7256C4.58243 10.3778 5.70514 9.37455 7.03811 9.34029C8.43102 9.30462 9.60701 10.2232 9.88959 11.5824C9.96189 11.9296 9.99805 11.8374 9.69311 11.9972ZM10.7958 11.2413C10.1698 9.43211 8.94433 8.41644 6.98626 8.43309C5.52484 8.44546 3.97969 9.46636 3.50207 11.2399C2.39744 10.4264 1.20433 8.42263 1.59728 6.06352C2.02115 3.51698 4.14905 1.57747 6.7346 1.38623C9.3073 1.19594 11.6892 2.80055 12.4856 5.26146C13.2758 7.70191 12.2539 10.0815 10.7958 11.2413Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16369 3.25343C5.86688 3.24962 4.81458 4.29764 4.81363 5.59303C4.81315 6.88319 5.85736 7.93263 7.14562 7.93643C8.44196 7.94024 9.49473 6.89222 9.49521 5.59683C9.49616 4.3062 8.45242 3.25676 7.16369 3.25343ZM7.15941 6.99926C6.38351 7.00116 5.75223 6.37369 5.75033 5.59874C5.74842 4.82236 6.37542 4.19155 7.15037 4.18965C7.92628 4.18775 8.55756 4.81522 8.55946 5.5897C8.56089 6.36608 7.93389 6.99736 7.15941 6.99926Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.5064887cc1340fb37abb8c42facf59a7.svg";
export { ForwardRef as ReactComponent };